"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var SizeSensor_1 = require("../SizeSensor");
var util_1 = require("../util");
var faccToHoc_1 = tslib_1.__importStar(require("../util/faccToHoc"));
var WidthSensor = (function (_super) {
    tslib_1.__extends(WidthSensor, _super);
    function WidthSensor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            width: Infinity,
            height: Infinity,
        };
        _this.onSize = function (size) {
            if (_this.state.width !== size.width) {
                _this.setState(size);
                _this.props.onWidth(size);
            }
        };
        return _this;
    }
    WidthSensor.prototype.render = function () {
        var _a = this.props, onWidth = _a.onWidth, _rest = tslib_1.__rest(_a, ["onWidth"]);
        var rest = _rest;
        rest.onSize = this.onSize;
        return util_1.h(SizeSensor_1.SizeSensor, rest);
    };
    WidthSensor.defaultProps = {
        onWidth: util_1.noop
    };
    return WidthSensor;
}(react_1.Component));
exports.WidthSensor = WidthSensor;
exports.withWidth = faccToHoc_1.default(WidthSensor, 'width', faccToHoc_1.divWrapper);
//# sourceMappingURL=index.js.map